module.exports = __webpack_public_path__ + "static/media/inf_44og65.a8681e36.mp3";